// import { info } from 'node-sass'
import React from 'react'
import { checkTextTranslation, checkTranslation } from '../../utils/useful'

class EditorInputNew extends React.Component {
    state = {
        options: [
            { label: 'Text style', icon: '/assets/icons/applets/general/text.png', function: '' },
            // { label: 'Text style', icon: '/assets/icons/useful/text.svg', function: '' },
            { section: true },
            { label: 'Text style', icon: '/assets/icons/applets/general/clock.png', function: '' },
            { label: 'Text style', icon: '/assets/icons/applets/general/message.png', function: '' },
            { label: 'Text style', icon: '/assets/icons/applets/general/help.png', function: '' },

            // { label: 'Text style', icon: '/assets/icons/useful/microphone.svg', function: '' },
            // { label: 'Text style', icon: '/assets/icons/useful/clip.svg', function: '' },
            // { label: 'Text style', icon: '/assets/icons/useful/text.svg', function: '' },

        ]
    }


    changeInputValue(target) {
        // console.log(target.value)
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

   

    onPaste = (e) => {
        e.preventDefault();
        const open = new RegExp('<', 'gi');
        const close = new RegExp('>', 'gi');

        const text = (e.originalEvent || e).clipboardData
            .getData('text/plain')
            .replace(open, '&lt')
            .replace(close, '&gt');
        document.execCommand('insertHTML', false, text)
    }



    render() {
        let info = this.props.header?.information
        return (
            <div className="w-100 h-100 editor-input" style={{borderRadius:'4px', border: '1px solid #f6f6f6'}}>
                <div className='flexc pb-1 pt-1' style={{background:'#f6f6f6',borderRadius:'4px 4px 0px 0px', borderBottom: '1px solid rgba(229,231,233,0.5)'}}>
                    {this.state.options.map((option, index) => {
                        if (option.section) {
                            return (
                                <div className='mld-2' style={{height:24,width:1,backgroundColor:'#e0e0e0'}}>
                                </div>
                            )
                        }
                        if (option.icon) {
                            return (
                                <button className='p-1 flexcc mld-2'>
                                    <img className='saturate-with-hover' src={option.icon} height={18} style={{opacity:0.7}} />
                                </button>
                            )
                        }
                    })}

                </div>
                <div role={"textbox"} onPaste={(e) => this.onPaste(e)} ref={el => this.editor = el} className="editor w-100 h-100 transpanet-input p-2" data-placeholder={checkTranslation(info.placeholder)} contentEditable={true} style={{ outline: 'none',minHeight:100, wordBreak: 'break-word' }}>

                </div>
            </div>
        )
    }
}

export default EditorInputNew;